<template>
  <div class="image_preview_btn_container">
    <v-btn
      class="image_preview_btn"
      :class="showPreview ? 'active' : ''"
      @click="togglePreview"
    >
      <v-icon v-if="showPreview">$imageCheck</v-icon>
      <v-icon v-if="!showPreview" class="xmark_outlined">$imageXMark</v-icon>
      <v-icon v-if="!showPreview" class="xmark_filled mt-1"
        >$imageXMarkFilled</v-icon
      >
      Vorschaubild
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "ImagePreviewButton",
  props: {
    showPreview: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    togglePreview() {
      this.$emit("toggleImagePreview");
    }
  }
};
</script>
<style lang="scss">
.image_preview_btn_container {
  display: flex;
  justify-content: center;
  align-items: center;

  .v-btn.image_preview_btn {
    display: flex;
    height: 32px !important;
    padding: 6px 16px !important;
    justify-content: center !important;
    align-items: center;
    gap: 20px !important;
    border-radius: 8px !important;
    background: var(--STANDARD-White, #fff) !important;
    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1) !important;

    .v-icon {
      margin-right: 10px;
    }

    .v-btn__content {
      color: #121212 !important;
      leading-trim: both;
      text-edge: cap;
      font-size: 18px !important;
      font-style: normal;
      font-weight: 400 !important;
      line-height: 18px !important; /* 100% */
    }

    .xmark_filled {
      display: none;
    }

    &:hover {
      .xmark_filled {
        display: block;
      }
      .xmark_outlined {
        display: none;
      }
    }

    &.active {
      background-color: #00636c !important;
      .v-btn__content {
        color: #fff !important;
        .v-icon {
          color: #fff !important;
          fill: #fff !important;
        }
      }
      &:hover {
        text-decoration: 1px dotted white !important;
      }
    }
  }
}
</style>
